(function () {
  // ---- selectors (uses elements inside the popup so it works with multiple sections) ----
  const popupIcon =
    document.querySelector('#popup-icon') ||
    document.querySelector('.free-coffee') ||
    document.querySelector('[data-popup-icon]');
  const popup = document.getElementById('email-popup');
  const overlay = document.getElementById('email-popup-overlay');
  // find the form inside the popup (your liquid renders: {% form 'customer' class='newsletter-form' %})
  const emailForm = popup ? popup.querySelector('.newsletter-form') : null;
  const emailInput = popup ? popup.querySelector('input[type="email"]') : null;
  const closeBtn = document.getElementById('email-popup-close');
  const thankyou = document.querySelector('.thank_you_msg');
  // success element is only rendered by Shopify when form.posted_successfully? is true
  const successEl = popup ? popup.querySelector('.newsletter-form__message--success') : null;

  if (!popup || !overlay) return; // nothing to do

  let isOpen = false;
  let openTween = null;

  // Helpers to animate or just show/hide when GSAP missing
  const hasGSAP = typeof gsap !== 'undefined';

  function openPopup(withFocus = true) {
    if (isOpen) return;
    isOpen = true;

    overlay.style.display = 'block';
    popup.style.display = 'block';
    overlay.setAttribute('aria-hidden', 'false');
    popup.setAttribute('aria-hidden', 'false');

    // lock scrolling
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (hasGSAP) {
      gsap.killTweensOf(popup);
      openTween = gsap.fromTo(
        popup,
        { y: '60vh', scale: 0.98, autoAlpha: 0 },
        {
          y: '0vh',
          scale: 1,
          autoAlpha: 1,
          duration: 0.95,
          ease: 'power4.out',
          overwrite: true,
          onComplete() {
            if (withFocus) try { emailInput && emailInput.focus(); } catch (e) {}
          },
        }
      );
      gsap.fromTo(overlay, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.6, ease: 'power2.out' });
    } else {
      // simple fallback
      overlay.style.opacity = 1;
      popup.style.opacity = 1;
      popup.style.transform = 'translate(-50%, -50%) scale(1)';
      if (withFocus) try { emailInput && emailInput.focus(); } catch (e) {}
    }
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;

    if (hasGSAP) {
      gsap.killTweensOf(popup);
      gsap.to(popup, {
        y: '60vh',
        scale: 0.98,
        autoAlpha: 0,
        duration: 0.65,
        ease: 'power3.in',
        onComplete() {
          popup.style.display = 'none';
          popup.setAttribute('aria-hidden', 'true');
        },
      });
      gsap.to(overlay, {
        autoAlpha: 0,
        duration: 0.55,
        ease: 'power2.in',
        onComplete() {
          overlay.style.display = 'none';
          overlay.setAttribute('aria-hidden', 'true');
        },
      });
    } else {
      overlay.style.opacity = 0;
      overlay.style.display = 'none';
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
    }

    // restore scrolling
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  // Click handlers
  if (popupIcon) {
    popupIcon.addEventListener('click', (ev) => {
      ev.preventDefault();
      openPopup();
    });
  }

  // overlay closes
  overlay.addEventListener('click', (e) => {
    e.preventDefault();
    closePopup();
  });

  // prevent clicks inside popup from bubbling to overlay
  popup.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  // close button
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  }

  // escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  });

  // keep focus inside popup while open (good for accessibility)
  document.addEventListener(
    'focus',
    function (ev) {
      if (!isOpen) return;
      if (!popup.contains(ev.target)) {
        ev.stopPropagation();
        try {
          emailInput && emailInput.focus();
        } catch (e) {}
      }
    },
    true
  );

  // form submit: animate press but let Shopify handle the submit (do not preventDefault)
  if (emailForm) {
    emailForm.addEventListener('submit', () => {
      if (hasGSAP) {
        gsap.to(popup, { scale: 0.985, duration: 0.06, yoyo: true, repeat: 1 });
      }
      // no preventDefault — allow server post + page reload
    });
  }

  // ---- AUTO-OPEN after a successful post (Shopify renders the success element server-side) ----
  // If successEl exists in the DOM after page load, it means form.posted_successfully? was true.
  document.addEventListener('DOMContentLoaded', function () {
    if (successEl) {
      // show the popup automatically and show the success message
      // hide the form area so the thank-you message is prominent
      try {
        // hide the form (if present)
        if (emailForm) {
          emailForm.style.display = 'none';
          thankyou.style.display='block'
          emailForm.setAttribute('aria-hidden', 'true');
        }

        // show the success element (override any inline display:none set in Liquid)
        successEl.style.display = 'block';
        successEl.setAttribute('aria-hidden', 'false');
        // make sure it's focusable and focus it for screen readers
        successEl.setAttribute('tabindex', '-1');

        // open the popup and focus the message
        openPopup(false); // openPopup(false) -> don't focus the email input
        // focus after a tiny delay so the popup open animation completes
        setTimeout(() => {
          try {
            successEl.focus();
          } catch (e) {}
        }, hasGSAP ? 600 : 50);
      } catch (e) {
        // fallback: if anything goes wrong, still open the popup
        openPopup();
      }
    }
  });

  // Optional: if you want to clear the success state on subsequent loads (so popup doesn't auto open again),
  // you could instruct Shopify to redirect to a clean URL after posting — but that's a server-side change.
})();
